<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Sampling Details </strong>
            
          </div>  
          
        
         
        <!----- SideBar All Design List ---->
   <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" >
        <div class="brand-card" >

         <!--  <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">
             <div class="col-md-12"><strong>{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">{{style_details.category_title}} >> {{style_details.sub_category_title}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
          </div>
 -->

<!-- For other user -->
<div class="header-tabs__navbar flex" style="margin-left:15px;">

  <router-link :to="'/design_details/' + route_id" v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager' || user_type=='Fit_Technician') && (style_details.operational_status=='FH-approved' || style_details.operational_status=='Measurement Chart-Uploaded' || style_details.operational_status=='TP-Uploaded' || style_details.operational_status=='BOM-Updated' || style_details.operational_status=='CAD-Uploaded')">   
    <div class="header-tabs__tab flex header-tabs__tab--active completed" data-tip="" data-class="dark-tooltip" currentitem="false" style="background-color:lightgray;color:black">
        <div class="header-tabs__tab-image">
        <img src="/img/ic-blue-check.2ce9e8ec.svg" alt="progress icon"></div>
        <div class="header-tabs__tab-block"><span class="title">Design details</span><span class="sub_title completed">Completed</span></div>
    </div>
  </router-link>

  <router-link :to="'/design_files/' + route_id"  v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager' || user_type=='Fit_Technician') && (style_details.operational_status=='FH-approved' || style_details.operational_status=='Measurement Chart-Uploaded' || style_details.operational_status=='TP-Uploaded' || style_details.operational_status=='BOM-Updated' || style_details.operational_status=='CAD-Uploaded')">
    <div class="header-tabs__tab flex completed" data-tip="" data-class="dark-tooltip" currentitem="false">
      <div class="header-tabs__tab-image"><img src="/img/ic-grey-check.87351b3c.svg" alt="progress icon"></div>
      <div class="header-tabs__tab-block"><span class="title">Files</span><span class="sub_title completed">Uploaded</span></div>
    </div>
  </router-link>

  <router-link :to="'/design_quotes/' + route_id"  v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager' || user_type=='Fit_Technician') && (style_details.operational_status=='FH-approved' || style_details.operational_status=='Measurement Chart-Uploaded' || style_details.operational_status=='TP-Uploaded' || style_details.operational_status=='BOM-Updated' || style_details.operational_status=='CAD-Uploaded')">
    <div class="header-tabs__tab flex completed" data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="header-tabs__tab-image"><img src="/img/ic-grey-check.87351b3c.svg" alt="progress icon"></div>
        <div class="header-tabs__tab-block"><span class="title">Quote</span><span class="sub_title completed">Approved</span></div>
    </div>
  </router-link>

<!--   <router-link :to="'/design_samples/' + route_id"  v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager') && style_details.operational_status=='FH-approved'">
    <div class="header-tabs__tab flex" data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="header-tabs__tab-image"><img src="/img/ic-orange-clock.2d90a802.svg" alt="progress icon"></div>
        <div class="header-tabs__tab-block"><span class="title">Sampling</span><span class="sub_title false">Requested</span></div>
    </div>
  </router-link>

  <router-link :to="'/production/' + route_id" v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager') && style_details.operational_status=='FH-approved'">
    <div class="header-tabs__tab flex header-tabs__tab--disabled" data-tip="Design can be moved to production after the Pre production sample is approved" data-class="dark-tooltip" currentitem="false">
        <div class="header-tabs__tab-image"></div>
        <div class="header-tabs__tab-block"><span class="title">Production</span><span class="sub_title false"></span></div>
    </div>
  </router-link>

  <router-link :to="'/design_messages/' + route_id"  v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager') && style_details.operational_status=='FH-approved'">
    <div class="header-tabs__tab flex messages" data-class="dark-tooltip" data-tip="" currentitem="false">
        <div class="header-tabs__tab-image"></div>
        <div class="header-tabs__tab-block"><span class="title">Messages</span><span class="sub_title false"></span></div>
    </div>
  </router-link> -->
</div>        

          


           
<!--    <b-row>
              <b-col sm="12" class="text-right" style="margin-top: 10px;" >
                
                <b-button type="button" variant="primary" size="md" v-b-modal.RequestSamplemodel>Request Sample</b-button>
              </b-col>
              </b-row> -->
         <div class="col-md-12">
              <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="data" :bordered="bordered" :fields="fielddata" caption-top>
              <template slot="table-caption"><b>PP sample</b></template>
                   <template slot="actions" slot-scope="row" >
                              <tr>
                               <b-button  variant="primary"  v-b-modal.RequestprotoSamplemodel
                                 @click="getuplodedfiledetails(row.item)">
                              Update Proto Status</b-button><br><br>
                               <b-button  variant="primary"  v-b-modal.Detailsprotomodel
                                 @click="getuplodedfiledetails(row.item)">
                              Show PP Details</b-button>
              </tr>
                </template>
          </b-table></div>
            <b-modal id="RequestprotoSamplemodel" size="xl" title="Update Proto Sample">
                <form >
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table col-md-12">
                                        <thead>
                                            <tr style="width: 100%">
                                                
                                                <th scope="col" class="heading_data">Mode Of Transport</th>
                                                <th scope="col" class="heading_data">Shipping Company Name</th>
                                                <th scope="col text-right" class="heading_data">Tracking Id</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr >

                                                
                                                <td>
                                                    <input class="form-control" type="text"/>
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text"/>
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text"
                                                    />
                                                </td>
                                                  
                                                
                                                 

                                            </tr>
                                          
                                                  
                                          
                                            
                                        <!--     <tr v-show="invoice_products.length === 0">
                                                <td colspan="6">
                                                    <p class="text-center alert-danger p-2">
                                                        No products added/available.
                                                    </p>
                                                </td>
                                            </tr> -->

                                        </tbody>
                                       
                                       
                                    </table>
                                </div>
                            </div>
                            
                            <div class="col-md-12 mb-4 text-center">
                                <button type='submit' v-bind:disabled="btnDisable" class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                                    <i class="fa fa-save"></i>
                                    Update Proto Sample
                                </button>
                            </div>
                        </div>
                    </form>  
              

            </b-modal>
           <b-modal id="RequestppSamplemodel" size="xl" title="Update PP Sample">
                <form >
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table col-md-12">
                                        <thead>
                                            <tr style="width: 100%">
                                                
                                                <th scope="col" class="heading_data">Mode Of Transport</th>
                                                <th scope="col" class="heading_data">Shipping Company Name</th>
                                                <th scope="col text-right" class="heading_data">Tracking Id</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr >

                                                
                                                <td>
                                                    <input class="form-control" type="text"/>
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text"/>
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text"
                                                    />
                                                </td>
                                                  
                                                
                                                 

                                            </tr>
                                          
                                                  
                                          
                                            
                                        <!--     <tr v-show="invoice_products.length === 0">
                                                <td colspan="6">
                                                    <p class="text-center alert-danger p-2">
                                                        No products added/available.
                                                    </p>
                                                </td>
                                            </tr> -->

                                        </tbody>
                                       
                                       
                                    </table>
                                </div>
                            </div>
                            
                            <div class="col-md-12 mb-4 text-center">
                                <button type='submit' v-bind:disabled="btnDisable" class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                                    <i class="fa fa-save"></i>
                                    Update PP Sample
                                </button>
                            </div>
                        </div>
                    </form>  
              

            </b-modal>
                    <b-modal id="Detailsprotomodel" size="xl" title="Proto Sample Details">
                  <div class="col-md-12">
               <b-table show-empty stacked="md" :busy6="isBusy"   :items="uplodeditems" :fields="uplodedfields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  :bordered="bordered"  > 
               <template slot="uplodedactions" slot-scope="row">
                  
                  <b-dropdown id="dropdown-dropup" dropup text="Drop-Up" variant="link" toggle-class="text-decoration-none" no-caret>
                                  <template v-slot:button-content>
                                    <span class="cui-options icons font-1xl d-block"></span>
                                  </template>
                                  <b-dropdown-item
                                  :href="row.item.file_path"
                                  target="_blank" >
                                  <i class="fa fa-download" aria-hidden="true" style="color: green;"></i>Download</b-dropdown-item>

                                  <b-dropdown-item >
                                   <span  @click="deletefile(row.item.id)"> <i class="fa fa-trash" aria-hidden="true" style="background-color: none; color: red; width: 20px;"></i>Delete</span>
                                  </b-dropdown-item>
                                </b-dropdown> 
             
                </template>
                           </b-table>
                         </div>
            </b-modal>
                     <b-modal id="Detailsppmodel" size="xl" title=" PP Sample Details">
                <div class="col-md-12">
                <b-table show-empty stacked="md" :busy6="isBusy"   :items="uplodeditems" :fields="uplodedfields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  :bordered="bordered"  > 
               <template slot="uplodedactions" slot-scope="row">
                  
                  <b-dropdown id="dropdown-dropup" dropup text="Drop-Up" variant="link" toggle-class="text-decoration-none" no-caret>
                                  <template v-slot:button-content>
                                    <span class="cui-options icons font-1xl d-block"></span>
                                  </template>
                                  <b-dropdown-item
                                  :href="row.item.file_path"
                                  target="_blank" >
                                  <i class="fa fa-download" aria-hidden="true" style="color: green;"></i>Download</b-dropdown-item>

                                  <b-dropdown-item >
                                   <span  @click="deletefile(row.item.id)"> <i class="fa fa-trash" aria-hidden="true" style="background-color: none; color: red; width: 20px;"></i>Delete</span>
                                  </b-dropdown-item>
                                </b-dropdown> 
             
                </template>
                           </b-table>
                         </div>
            </b-modal>

          
<!-- 
              <b-row>
              <b-col sm="12" class="text-right" style="margin-top: 10px;" >
                
                <b-button type="button" variant="primary" size="md"  v-b-modal.RequestppSamplemodel>Request Sample</b-button>
              </b-col>
              </b-row> -->
         <div class="col-md-12">
            <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="data" :bordered="bordered" :fields="fielddata" caption-top>
              <template slot="table-caption"><b>PP sample</b></template>
                   <template slot="actions" slot-scope="row">
                              <tr>
                               <b-button  variant="primary"  v-b-modal.RequestppSamplemodel
                                 @click="getuplodedfiledetails(row.item)">
                              Update  PP Status</b-button>&nbsp;
                               <b-button  variant="primary"  v-b-modal.Detailsppmodel
                                 @click="getuplodedfiledetails(row.item)">
                              Show PP Details</b-button>
                             </tr>
                </template>
          </b-table>
        </div>
     </div>
        </div>
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
export default {
   name: 'Tabs',
     components: {
        sidebarAllDesignsComponent
      },  

  data: function () {
    return {
      isBusy: false,
      customer: {},
      outlined:true,
      bordered: true,
    
     
      uplodeditems:[],
      dlvstatus:[],
      img1:[],
      imgpath:[],
      urlImg: [],
       customlogdata: [],
       smslogdata: [],
        fields: ['Mode Of Transport', 'Factory/ Due Date', 'Status',{key:'actions' , label:'Action' }],
        data: [
          { isActive: true, TypeSize: 40, Status: 'Dickerson', FactoryDueDate: 'Macdonald' },
          // { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          // { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          // { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
    
      // fields: [{key: 'ggg', label: 'Type/Size'}, {key: 'hhh',label:'Factory/ Due Date'}, {key: 'ppp',label:'Status'},{key:'actions' , label:'Action' }],
     
      fielddata:['Type/Size', 'Factory/ Due Date', 'Status',{key:'actions' , label:'Action' }],
          uplodedfields: [
                          
    
          {key: 'file_name', label: 'Style Id' },
          { key: 'category_name',label: 'Style Name'},
          
          { key: 'created_date', label:'Description'},
          { key: 'created_date1', label:'Type/Size'},
          { key: 'created_date2', label:'Factory/Due Date'},
          { key: 'created_date3', label:'Buyer Name'},
           { key: 'created_date4', label:'Address'},
          { key: 'created_date5', label:'Date'},
          { key: 'uplodedactions', label:'Action'},
          

        ],
      ConsignmentMasterGetdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      currentPage: 1,
       perPage:  10,
       sortBy: null,
       sortDesc: true,
       sortDirection: 'desc',
       filter: null,
       totalRows: 0,
       selected_style_id: 0,
       user_type: '',
       //style: '',
    }
  },
  created: function () {
    document.getElementById("overlay").style.display = "none";
    var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
  },
  methods: {
    btnDisable: function(){

    },
    validateForm(scope) {
       
      var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var shipmentid = this.customer.shipmentid
          var searchvalues = shipmentid.split(',')
          for (var i = 0; i < searchvalues.length; i++) {
            searchvaluesarr.push(`${searchvalues[i]}`)
          }
          const customerGetAllobj = {
            shippingid: searchvaluesarr
          }


          axios.post(`${CONSTANTS.MIGRATION_API_URL}/consignmentactivitytrackinggetweb`, customerGetAllobj)
            .then((result) => {
              document.getElementById("overlay").style.display = "none";

              if (result.body.returnmsg && result.body.returnmsg === 'UnSuccessful') {
                this.data = []
                //alert('Result not found')
                this.isConsignmentActivityTrackingGetWeb = 1
                // var searchlisting = document.getElementById('searchlisting')
                // searchlisting.style.display = 'block'
              } else if (result.body.length === 0) {
                //alert('Result not found')
                this.data = []
                this.isConsignmentActivityTrackingGetWeb = 1
                // var searchlisting = document.getElementById('searchlisting')
                // searchlisting.style.display = 'block'
              } else {
                this.data = result.body
                this.isConsignmentActivityTrackingGetWeb = 1
                // var searchlisting = document.getElementById('searchlisting')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })


          // Added By Sachin On 06/02/2020  
          var shipmentidget1 = this.customer.shipmentid
          const customerstatusobj = {
          shippingid: `${shipmentidget1}`
          }
          this.isBusy = true;
          axios.post(`${CONSTANTS.MIGRATION_API_URL}/getlogisticlogdetails`, customerstatusobj).then((result) => {
              //document.getElementById("overlay").style.display = "none";

              if (result.body.returnvalue.length > 0) {
                
                this.logisticlogdata = result.body.returnvalue
                //conole.log("this.logisticlogdata",this.logisticlogdata);
                this.isGetlogisticlogdetails = 1
                this.isBusy =false
                
              } else {
                //alert('Result not found')
                this.logisticlogdata = []
                this.isGetlogisticlogdetails = 1
                this.isBusy = false

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
          // Added By Sachin On 06/02/2020

            // Added By Sachin On 10/04/2020  
          var shippingid = this.customer.shipmentid
          const customobj = {
          shippingid: `${shippingid}`
          }
          this.isBusy = true;
          axios.post(`${CONSTANTS.MIGRATION_API_URL}/statusforcustom`, customobj).then((result) => {
              //document.getElementById("overlay").style.display = "none";

              if (result.body.returnvalue.length > 0) {
                
                this.customlogdata = result.body.returnvalue
                //conole.log("this.customlogdata",this.customlogdata);
                this.isGetlogisticlogdetails = 1
                this.isBusy = false
                
              } else {
                //alert('Result not found')
                this.customlogdata = []
                this.isGetlogisticlogdetails = 1
                this.isBusy = false;
                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })


            //added by mukesh 0n 02-july-2020
            var shippingid = this.customer.shipmentid;
          
          const smsobj = {
          shippingid: `${shippingid}`
          }
          this.isBusy = true;
          axios.post(`${CONSTANTS.MIGRATION_API_URL}/displaysmslog`, smsobj).then((result) => {
             // document.getElementById("overlay").style.display = "none";

              if (result.body.returnvalue.length > 0) {
                
                this.smslogdata = result.body.returnvalue
                //conole.log("this.customlogdata",this.customlogdata);
                this.isGetlogisticlogdetails = 1
                this.isBusy = false
                
              } else {
                //alert('Result not found')
                this.smslogdata = []
                this.isGetlogisticlogdetails = 1
                this.isBusy = false;
                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
            //end
        

          // Added By Sachin On 06/02/2020    




          var shipmentidget = this.customer.shipmentid
          const Getobj = {
            shippingid: `${shipmentidget}`
          }
         // this.isBusy = true;
          axios.post(`${CONSTANTS.MIGRATION_API_URL}/consignmentmasterget`, Getobj)
            .then((result) => {
              //document.getElementById("overlay").style.display = "none";

              if (result.body.length > 0) {
                 
                this.ConsignmentMasterGetdata = result.body
                this.img1 = result.body[0].vendorsign
                this.dlvstatus = result.body[0].shipmentstatus
                
                this.urlImg = result.body[0].shipment_images
                this.imgpath= JSON.parse(this.urlImg);
                
                this.isConsignmentMasterGetStatus = 1

                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } else {
                //alert('Result not found')
                this.ConsignmentMasterGetdata = []
                this.isConsignmentMasterGetStatus = 1
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
        }
      })
    },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
      var searchlisting = document.getElementById('searchlisting')
      searchlisting.style.display = 'none'
      var searchlisting2 = document.getElementById('searchlisting2')
      searchlisting2.style.display = 'none'
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }
/*.table button {
    background: #f6f7f9!important;
    color: white!important;
    border: none;
}*/
</style>
